import { getProjectBySlug } from '../../../../data/projects';
import { CaseStudyPage } from '../../../../components/caseStudy';

const project = getProjectBySlug('bar-scene');

const BarScenePage = () => <CaseStudyPage project={project} />;

export default BarScenePage;
